import React from "react";
import DataTablePagination from "../DataTablePagination";

/**
 * DataTableFooter
 *
 * This component renders the footer area of the DataTable, typically used
 * for pagination controls, summary info, or other table-wide actions.
 *
 * It acts as a container and passes pagination props to `DataTablePagination`.
 *
 * @component
 * @param {Object} props
 * @param {number} props.total - Total number of records in the dataset.
 * @param {Object} props.query - Current table query state (page, pageSize, search, sort).
 * @param {Function} props.setQuery - Function to update the query state.
 * @param {number[]} [props.pageSizeOptions=[50,1000,150,200,250]] - Dropdown options for page sizes.
 * @param {Object} [props.style] - Optional inline styles for footer container.
 * @param {string} [props.className] - Additional class names for footer styling.
 *
 * @example
 * <DataTableFooter
 *   total={120}
 *   query={query}
 *   setQuery={setQuery}
 *   pageSizeOptions={[10, 25, 50]}
 * />
 */
const DataTableFooter = ({
  total,
  query,
  setQuery,
  pageSizeOptions = [50, 100, 150, 200, 250],
  style,
  className
}) => {
  return (
    <div
      style={{
        ...style,
      }}
      className={className}
    >
      {/* Pagination controls */}
      <DataTablePagination
        query={query}
        setQuery={setQuery}
        totalRecords={total}
        pageSizeOptions={pageSizeOptions}
      />
    </div>
  );
};

export default DataTableFooter;
